// searchUtils.js
import axios from 'axios'
import debounce from 'lodash/debounce'

export function searchItems(
    url,
    column,
    query,
    authentication,
    setLoading,
    setData
) {
    if (query && query.length > 2) {
        console.log('Query:', query, 'Column:', column)
        setLoading(true)
        axios
            .get(url + '/search/' + column + '/' + query, authentication)
            .then(response => {
                setData(response.data)
            })
            .catch(error => {
                console.error('Axios error: ', error)
            })
            .finally(() => {
                setLoading(false)
            })
    }
}

export const delayedSearchItems = debounce(searchItems, 500)
